/**
 * FT12-U18: Collections Worklist (FSD 2.2.3.8 / 2.2.3.9). The INT packet spreads
 * `AR_COLLECTIONS_ROUTES` and adds the nav item `ar-collections`. The route's permission is
 * the worklist endpoint's: `ar.collections.read`. Resolves FT9's NoScreen deeplink marker
 * for `/ar/collections` (the broken-promise notification links here).
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_COLLECTIONS_PERMISSIONS } from '@/modules/ar/collections/permissions'

export const AR_COLLECTIONS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/collections',
    name: 'ar-collections',
    component: () => import('@/modules/ar/collections/CollectionsWorklistView.vue'),
    meta: {
      titleKey: 'ar.routeTitles.collections',
      permission: AR_COLLECTIONS_PERMISSIONS.read,
    },
  },
]
